import { render, staticRenderFns } from "./UploadPortraitPhoto.vue?vue&type=template&id=3abb4579&scoped=true&"
import script from "./UploadPortraitPhoto.vue?vue&type=script&lang=js&"
export * from "./UploadPortraitPhoto.vue?vue&type=script&lang=js&"
import style0 from "./UploadPortraitPhoto.vue?vue&type=style&index=0&id=3abb4579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abb4579",
  null
  
)

export default component.exports